( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function init() {
            updateSearchFields();
        }

        function updateSearchFields() {
            if ( window.location.search.match( /s=.+/gmi ) ) {
                var searchFieldElems = $( '.js--search-field' );

                var queryString = window.location.search.substring( 1 );
                var queryStringArr = queryString.split( '&' );
                var query = queryStringArr
                    .map( function( keyVal ) {
                        return keyVal.split( '=' );
                    } )
                    .filter( function( keyValArr ) {
                        return keyValArr[ 0 ] === 's';
                    } )
                    .reduce( function( str, keyValArr ) {
                        return keyValArr[ 1 ] || '';
                    }, '' )
                    .replace( /(\+)/gmi, ' ' );

                if ( query && typeof query === 'string' ) {
                    searchFieldElems.each( function( i, el ) {
                        $( el ).val( query );
                    } );
                }
            }
        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();
    } );
} )( window, document, jQuery );
